import { SystemAnimation } from '@naker/services/System/systemAnimation';

import { Vector3 } from '@babylonjs/core/Maths/math';
import { ArcRotateCamera } from '@babylonjs/core/Cameras/arcRotateCamera';

export class coreSystem extends SystemAnimation {

    camera: ArcRotateCamera;

    constructor(canvas: HTMLCanvasElement) {
        super(canvas);
        this.camera = new ArcRotateCamera('main_camera', Math.PI / 2, Math.PI / 2, 10, new Vector3(0, 0, 0), this.scene);
        this.camera.setTarget(new Vector3(0, 0, 0));
        this.camera.minZ = 0;
        
        this.optimize();
        this.scene.blockMaterialDirtyMechanism = true;
    }
}